import { Tooltip } from 'antd';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import addHover from '../../../assets/img/gantt/add-hover.png';
import addIcon from '../../../assets/img/gantt/add-new.png';
import completeIcon from '../../../assets/img/gantt/complete-new.png';
import deleteHover from '../../../assets/img/gantt/delete-hover.png';
import deleteIcon from '../../../assets/img/gantt/delete-new.png';
import emptyIcon from '../../../assets/img/gantt/empty-new.png';
import hoverIcon from '../../../assets/img/gantt/hover-new.png';
import uncompleteIcon from '../../../assets/img/gantt/uncomplete-new.png';

const buttonsCol = (gantt, t, permissionGantt) => {
  const name = 'buttons';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label:
      '<div style="font-size: 26px; color: #333333;font-weight: 400; cursor: pointer" onclick="window.to_use_react_gantt.createTask({ duration: 9 })"> + </div>',
    width: 90,
    align: 'center',
    resize: false,
    hide: !isVisible,
    ignore_as_column: true,
    template: function (activity) {
      const isOdd = gantt.oddColsConfig?.buttons || false;
      const currentSector = JSON.parse(sessionStorage.getItem('currentSector'));
      if (!currentSector) return '';

      // Progress btn
      let progressBtnHtml;
      const canEdit = permissionGantt.gantt !== 'V';

      if (activity.progress <= 99.9) {
        let onClickStrProgressCompleted = '';
        if (canEdit) {
          onClickStrProgressCompleted = `
            onclick="
              window.to_use_react_gantt.completeTask(${activity.id});
              window.TimerManagerSingleton.getInstance().clearTimer('progressTimer-${activity.id}');
              const progressCompletedCallback = () => {
                window.to_use_react_gantt.updateExpectedGlobal();
                window.to_use_react_gantt.executeAutoScheduleExternal();
              };
              window.TimerManagerSingleton.getInstance().registerAutoTimeout(
                progressCompletedCallback,
                500,
                'progressTimer-${activity.id}'
              )
            "
          `;
        }
        progressBtnHtml = `
          <span class="complete-btn-task-gantt" ${onClickStrProgressCompleted}>
              <img class="complete-empty-gantt" width="15" src="${emptyIcon}" />
              <img class="complete-hover-gantt" width="15" src="${hoverIcon}" />
          </span>
        `;
      } else {
        let onClickStrProgressUncompleted = '';
        if (canEdit) {
          onClickStrProgressUncompleted = `
            onclick="
              window.to_use_react_gantt.uncompleteTask(${activity.id});
              window.TimerManagerSingleton.getInstance().clearTimer('progressTimer-${activity.id}');
              const progressUncompletedCallback = () => {
                window.to_use_react_gantt.updateExpectedGlobal();
                window.to_use_react_gantt.executeAutoScheduleExternal();
              };
              window.TimerManagerSingleton.getInstance().registerAutoTimeout(
                progressUncompletedCallback,
                500,
                'progressTimer-${activity.id}'
              )
            "
          `;
        }
        progressBtnHtml = `
          <span class="uncomplete-btn-task-gantt" ${onClickStrProgressUncompleted}>
              <img class="uncomplete-empty-gantt" width="15" src="${completeIcon}" />
              <img class="uncomplete-hover-gantt" width="15" src="${uncompleteIcon}" />
          </span>
        `;
      }

      // Add btn
      let addTaskBtnHtml;
      if (canEdit) {
        const onClickStrAdd = `onclick="window.to_use_react_gantt.createTaskWithChild({ duration: ${parseInt(currentSector.hoursPerDay)} }, ${activity.id}, ${activity.proplannerId})"`;
        addTaskBtnHtml = `
          <span class="add-btn-task-gantt" ${onClickStrAdd}>
              <img class="add-empty-gantt" width="15" src="${addIcon}" />
              <img class="add-hover-gantt" width="15" src="${addHover}" />
          </span>
        `;
      } else {
        addTaskBtnHtml = `
          <Tooltip title="${t('not_permissions_actions')}">
              <span class="add-btn-task-gantt" style="cursor: not-allowed">
                  <img class="add-empty-gantt" width="15" src="${addIcon}" />
                  <img class="add-hover-gantt" width="15" src="${addHover}" />
              </span>
          </Tooltip>
        `;
      }

      // Delete btn
      let deleteTaskBtnHtml;
      if (activity.correlative_id === 0) {
        deleteTaskBtnHtml = '<span class="delete-task-gantt-btn"></span>';
      } else {
        let onClickStrDel = '';
        if (canEdit) {
          onClickStrDel = `onclick="window.to_use_react_gantt.trashTask(${activity.id})"`;
        }
        deleteTaskBtnHtml = `
          <span class="delete-task-gantt-btn" ${onClickStrDel} style="${!canEdit ? 'cursor: not-allowed' : ''}">
              <img class="delete-empty-gantt" width="15" src="${deleteIcon}" />
              <img class="delete-hover-gantt" width="15" src="${deleteHover}" />
          </span>
        `;
      }

      return `
        <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
            <div style="position: relative; left: -22px">
                ${addTaskBtnHtml}
                ${progressBtnHtml}
                ${deleteTaskBtnHtml}
            </div>
        </div>
      `;
    },
    groupable: false,
    orderable: false,
    orderable_switch: ['1 → 9', '9 → 1'], // Should this be here if orderable is false?
    filterable: false,
  };
};

export default buttonsCol; 